import React from 'react'

/**
 * Minimal `**bold**` → <strong> for stems, options, and review copy (source is markdown-lite).
 */
export function CertificationInlineRich({ text, className = '', strongClassName = 'font-semibold text-white' }) {
  if (text == null || text === '') return null
  const parts = String(text).split(/\*\*/)
  return (
    <span className={className}>
      {parts.map((part, i) =>
        i % 2 === 1 ? (
          <strong key={i} className={strongClassName}>
            {part}
          </strong>
        ) : (
          <span key={i}>{part}</span>
        )
      )}
    </span>
  )
}

export function CertificationRichParagraph({ text, className = '', strongClassName }) {
  if (!text) return null
  return (
    <div className={className}>
      <CertificationInlineRich text={text} strongClassName={strongClassName} />
    </div>
  )
}
